<template>
    <label class="font-medium text-sm text-gray-700" :class="labelClass">
        <template v-if="value">{{ value }}</template>
        <template v-else>
            <slot></slot>
        </template>
    </label>
</template>

<script>
export default {

    props: {
        inline: {
            default: false
        },
        value: String
    },

    computed: {
        labelClass() {
            return this.inline ? 'inline-flex items-center' : 'block';
        }
    }
};
</script>
